<div class='container flex flex-col gap-8'>
    <div class="flex flex-row justify-between items-center w-full">
        <h1 class="heading">{{ "TABLE_PROJECT" | translate }}</h1>
        <div *ngIf="isCPP()" class="flex flex-row items-center h-12 gap-4">
            <button *ngIf="isAdmin()" mat-flat-button (click)="autoArchiving()" class="text-base p-5 rounded-lg font-extrabold text-tw-lightgrey bg-tw-secondary border-tw-secondary border-1px">
                {{"AUTOMATIC_ARCHIVE" | translate}} </button>
            <button mat-flat-button [routerLink]="['/project/create/master']" class="text-base p-5 rounded-lg font-extrabold text-tw-lightgrey bg-tw-secondary border-tw-secondary border-1px">
                <mat-icon>add</mat-icon> {{ "MENU.CREATE_MASTER" | translate }} </button>
            <button mat-button [routerLink]="['/project/create/child']" class="text-base p-5 rounded-lg font-extrabold text-tw-primary bg-white !border-gray-300 border-1px">
                <mat-icon>add</mat-icon> {{ "MENU.CREATE_CHILD" | translate }} </button>
            <div class="flex border-l-[1px] border-gray-300 h-full"></div>
            <button mat-button [routerLink]="['/project/edit']" class="text-base p-5 rounded-lg font-extrabold text-tw-primary bg-white !border-gray-300 border-1px">
                <mat-icon>edit</mat-icon> {{ "MENU.EDIT_PROJECT" | translate }} </button>
        </div>
    </div>
    <app-project-filters [(filters)]="filters" (onFilter)="onFilter()"></app-project-filters>
    <!-- RECENTLY OPENED -->
    <app-recent-project-cards *ngIf="!isClient()" class="block"></app-recent-project-cards>
    <mat-divider></mat-divider>
    <!-- PROJECTS -->
    <div class="w-full">
        <h1 class="!text-tw-text-dark !italic !font-bold !font-segoe">{{ 'ACTUAL_PROJECTS' | translate }}</h1>
        <div>
            <app-project-cards-skeleton *ngIf="loading"></app-project-cards-skeleton>
            <ng-container *ngIf="!loading && !mapped_entities.length"> {{ "NORESULT" | translate }} </ng-container>
            <ng-container *ngIf="!loading && mapped_entities.length">
                <app-project-master-card *ngFor="let masterGroup of mapped_entities" [masterGroup]="masterGroup"></app-project-master-card>
            </ng-container>
        </div>
    </div>
    <mat-paginator #paginator [length]="page.total" [pageSize]="page.$limit" [pageSizeOptions]="[10, 25, 50, 100,150,200]" (page)="onPage($event)"></mat-paginator>
</div>
<app-footer></app-footer>